export class UpdateFournisseurAgree
{
    fournisseurAgreeId: number;
    marcheId: number;
    codeClient: String;
    numeroRct:String;
    nomComplet:String;
}